import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    NumberColumn,
  } = columns(data);

  return [
    {
      Header: 'Route information',
      columns: [
        new NumberColumn('Inbound', 'inboundRouteCount'),
        new NumberColumn('Outbound', 'outboundRouteCount'),
      ],
    },
  ];
};
